/*
 * @Descripttion:
 * @Author: lijingjing56
 * @Date: 2024-12-23 18:35:30
 * @LastEditors: lijingjing56
 * @LastEditTime: 2025-01-10 10:06:46
 */
import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
//  组件需定义为异步组件
const home = () => import('../views/home/index.vue');
const solution = () => import('../views/solution/index.vue');
const aboutUs = () => import('../views/aboutUs/index.vue');
const product = () => import('../views/product/index.vue');
const login = () => import('../views/login/index.vue');
const accountManage = () => import('../views/accountManage/index.vue');
const applyBind = () => import('../views/accountManage/applyBind/index.vue');
const settleList = () => import('../views/settle/index.vue');
const settleApply = () => import('../views/settle/settleApply/index.vue');
// const studyBook = () => import('../views/study/index.vue');

const routes = [
    { path: '/cloud/home', redirect: '/home' },
    { path: '/home', component: home },
    { path: '/cloud/market', component: home },
    { path: '/cloud/solution', component: solution },
    { path: '/cloud/login', component: login },
    { path: '/cloud/about/us', component: aboutUs },
    { path: '/cloud/accountManage', component: accountManage },
    { path: '/cloud/applyBind', component: applyBind },
    { path: '/cloud/settle', component: settleList },
    { path: '/cloud/applySettle', component: settleApply },
    // { path: '/cloud/study', component: studyBook },
    { path: '/cloud/product', component: product },
    { path: '/cloud/:product', component: product },
]

export function createRouter() {
	return new Router({
		mode: 'history',
		routes,
		base: '/'
	})
}